import { call, put, takeEvery } from "redux-saga/effects";
import { chuongTrinhDaoTaoChiTietApi } from "../../../api/ctdt/chuongTrinhDaoTaoChiTietApi";
import { chuongTrinhDaoTaoNhomTuChonApi } from "../../../api/ctdt/chuongTrinhDaoTaoNhomTuChonApi";
import { IChuongTrinhDaoTaoChiTiet } from "../../../model/respone/ctdt/IChuongTrinhDaoTaoChiTiet";
import { IChuongTrinhDaoTaoChiTietBatchResult } from "../../../model/respone/ctdt/IChuongTrinhDaoTaoChiTietBatchResult";
import { IChuongTrinhDaoTaoNhomTuChon } from "../../../model/respone/ctdt/IChuongTrinhDaoTaoNhomTuChon";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eChuongTrinhDaoTaoChiTietActionIds, IChuongTrinhDaoTaoChiTietActionTypeBase, IChuongTrinhDaoTaoChiTietActionTypes } from "../../action-types/ctdt/IChuongTrinhDaoTaoChiTietActionTypes";
import { rootActions } from "../../actions/rootActions";
import { IChuongTrinhDaoTaoRangBuoc } from "../../../model/respone/ctdt/IChuongTrinhDaoTaoRangBuoc";
import { IIdsRequest } from "../../../model/request/IIdsRequest";

/**
 * LT_VB2: dispatch SYNC_SIBLING_CHITIETS cho mỗi sibling từ BatchResult.
 * Replace state ChiTiet trực tiếp — KHÔNG re-fetch (0 HTTP call thêm).
 */
function* syncSiblingsFromBatch(batch: IChuongTrinhDaoTaoChiTietBatchResult): any {
    if (!batch?.siblings) return;
    for (const [siblingIdDt, siblingChiTiets] of Object.entries(batch.siblings)) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chiTiet.SYNC_SIBLING_CHITIETS({
            id_dt: Number(siblingIdDt),
            data: siblingChiTiets as any
        }));
    }
}

export function* chuongTrinhDaoTaoChiTietSaga(): any {
    yield takeEvery(eChuongTrinhDaoTaoChiTietActionIds.LOAD_BY_CTDT_START, loadWorker);
    yield takeEvery(eChuongTrinhDaoTaoChiTietActionIds.UPDATE_NHOMTUCHON_CONFIG_START, updateNhomTuChonConfigWorker);
    yield takeEvery(eChuongTrinhDaoTaoChiTietActionIds.UPDATE_START, updateWorker);
    yield takeEvery(eChuongTrinhDaoTaoChiTietActionIds.ADD_START, addWorker);
    yield takeEvery(eChuongTrinhDaoTaoChiTietActionIds.DELETE_START, deleteWorker);
    yield takeEvery(eChuongTrinhDaoTaoChiTietActionIds.SAVE_RANGBUOC_START, saveRangBuocWorker);
    yield takeEvery(eChuongTrinhDaoTaoChiTietActionIds.DELETE_RANGBUOC_START, deleteRangBuocWorker);
}

function* loadWorker(action: IChuongTrinhDaoTaoChiTietActionTypes): any {
    const id_dt = action.payload as number;
    const res: IBaseRespone = yield call(chuongTrinhDaoTaoChiTietApi.SelectByCtdt, id_dt);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chiTiet.LOAD_BY_CTDT_SUCCESS({
            id_dt,
            data: res.data
        }));
    } else {
        yield put(
            rootActions.chuongTrinhDaoTaoWrapper.chiTiet.LOAD_BY_CTDT_ERROR({
                id_dt,
                data: res.message ?? "Có lỗi"
            })
        );
    }
}

function* updateNhomTuChonConfigWorker(action: IChuongTrinhDaoTaoChiTietActionTypes): any {
    const payload = action.payload as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoNhomTuChon>;
    const res: IBaseRespone = yield call(chuongTrinhDaoTaoNhomTuChonApi.InsertOrUpdate, payload.data);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chiTiet.UPDATE_NHOMTUCHON_CONFIG_SUCCESS({
            id_dt: payload.id_dt,
            data: res.data
        }));
    } else {
        yield put(
            rootActions.chuongTrinhDaoTaoWrapper.chiTiet.UPDATE_NHOMTUCHON_CONFIG_ERROR({
                id_dt: payload.id_dt,
                data: res.message ?? "Có lỗi"
            })
        );
    }
}

function* updateWorker(action: IChuongTrinhDaoTaoChiTietActionTypes): any {
    const payload = action.payload as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoChiTiet[]>;
    const isLtVb2 = payload.mode === 'lt_vb2';
    const res: IBaseRespone = yield call(
        isLtVb2 ? chuongTrinhDaoTaoChiTietApi.UpdatesLtVb2 : chuongTrinhDaoTaoChiTietApi.Updates,
        payload.data
    );
    if (res.is_success) {
        if (isLtVb2) {
            const batch = res.data as IChuongTrinhDaoTaoChiTietBatchResult;
            yield put(rootActions.chuongTrinhDaoTaoWrapper.chiTiet.UPDATE_SUCCESS({
                id_dt: payload.id_dt,
                data: batch.primary as any
            }));
            yield call(syncSiblingsFromBatch, batch);
        } else {
            yield put(rootActions.chuongTrinhDaoTaoWrapper.chiTiet.UPDATE_SUCCESS({
                id_dt: payload.id_dt,
                data: res.data
            }));
        }
    } else {
        yield put(
            rootActions.chuongTrinhDaoTaoWrapper.chiTiet.UPDATE_ERROR({
                id_dt: payload.id_dt,
                data: res.message ?? "Có lỗi"
            })
        );
    }
}


function* deleteWorker(action: IChuongTrinhDaoTaoChiTietActionTypes): any {
    const payload = action.payload as IChuongTrinhDaoTaoChiTietActionTypeBase<IIdsRequest>;
    const isLtVb2 = payload.mode === 'lt_vb2';
    const res: IBaseRespone = yield call(
        isLtVb2 ? chuongTrinhDaoTaoChiTietApi.DeletesLtVb2 : chuongTrinhDaoTaoChiTietApi.Deletes,
        payload.data
    );
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chiTiet.DELETE_SUCCESS({
            id_dt: payload.id_dt,
            data: res.data
        }));
        if (isLtVb2) {
            yield call(syncSiblingsFromBatch, res.data as IChuongTrinhDaoTaoChiTietBatchResult);
        }
    } else {
        yield put(
            rootActions.chuongTrinhDaoTaoWrapper.chiTiet.DELETE_ERROR({
                id_dt: payload.id_dt,
                data: res.message ?? "Có lỗi"
            })
        );
    }
}

function* addWorker(action: IChuongTrinhDaoTaoChiTietActionTypes): any {
    const payload = action.payload as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoChiTiet[]>;
    const isLtVb2 = payload.mode === 'lt_vb2';
    const res: IBaseRespone = yield call(
        isLtVb2 ? chuongTrinhDaoTaoChiTietApi.InsertsLtVb2 : chuongTrinhDaoTaoChiTietApi.Inserts,
        payload.data
    );
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chiTiet.ADD_SUCCESS({
            id_dt: payload.id_dt,
            data: res.data
        }));
        if (isLtVb2) {
            yield call(syncSiblingsFromBatch, res.data as IChuongTrinhDaoTaoChiTietBatchResult);
        }
    } else {
        yield put(
            rootActions.chuongTrinhDaoTaoWrapper.chiTiet.ADD_ERROR({
                id_dt: payload.id_dt,
                data: res.message ?? "Có lỗi"
            })
        );
    }
}

function* saveRangBuocWorker(action: IChuongTrinhDaoTaoChiTietActionTypes): any {
    const payload = action.payload as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoRangBuoc>;
    let res: IBaseRespone;
    if (payload.data.id_rb > 0) {
        res = yield call(chuongTrinhDaoTaoChiTietApi.UpdateRangBuoc, payload.data);
    } else {
        res = yield call(chuongTrinhDaoTaoChiTietApi.InsertRangBuoc, payload.data);
    }
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chiTiet.SAVE_RANGBUOC_SUCCESS({
            id_dt: payload.id_dt,
            data: res.data
        }));
    } else {
        yield put(
            rootActions.chuongTrinhDaoTaoWrapper.chiTiet.SAVE_RANGBUOC_ERROR({
                id_dt: payload.id_dt,
                data: res.message ?? "Có lỗi"
            })
        );
    }
}

function* deleteRangBuocWorker(action: IChuongTrinhDaoTaoChiTietActionTypes): any {
    const payload = action.payload as IChuongTrinhDaoTaoChiTietActionTypeBase<IIdsRequest>;
    const res: IBaseRespone = yield call(chuongTrinhDaoTaoChiTietApi.DeleteRangBuocs, payload.data);
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chiTiet.DELETE_RANGBUOC_SUCCESS({
            id_dt: payload.id_dt,
            data: res.data
        }));
    } else {
        yield put(
            rootActions.chuongTrinhDaoTaoWrapper.chiTiet.DELETE_RANGBUOC_ERROR({
                id_dt: payload.id_dt,
                data: res.message ?? "Có lỗi"
            })
        );
    }
}
